import { AutoMap } from "@automapper/classes";
import { EMesureTerrainStatus } from "./enums/mesure-terrrain-status";
import { Operator } from "./operator";
import { ProcessSamplingCondition } from "./process-sampling-condition";
import { Securite } from "./securite";

export class ProcessMeasure {
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Status!: EMesureTerrainStatus;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    Color!: string;
    // @AutoMap()
    // SamplingID: number;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    ProcessSamplingCondition!: ProcessSamplingCondition;
    @AutoMap(() => [Operator])
    ProcessOperatorList: Operator[] = [];
    @AutoMap()
    Securite!: Securite;


    get OperatorsCount() {
        return this.ProcessOperatorList.length;
    }
    
    get BatteryCount() {
        return this.ProcessOperatorList.map(x => x.CassetteList.map(y => y.Pompe)).flat(2).length;
    }

    get CassetteCount() {
        if (!this.ProcessOperatorList || !this.ProcessOperatorList[0]) {
            return 0;
        }
        return this.ProcessOperatorList[0].CassetteList.length;
    }

    public constructor(init?: Partial<ProcessMeasure>) {
        Object.assign(this, init);
    }
}